import React from 'react';
import PropTypes from 'prop-types';

import GuestUploadsRow from './guest_upload_links_row';
import './styles/main.scss';

class GuestUploadsManagement extends React.Component {
  state = {
    queryString: null,
    visibleLinks: this.props.uploadLinks
  }

  updateSearch = (event) => {
    this.setState({ queryString: event.target.value });
  }

  deleteGuestUploadLink = (uploadLinkKey) => {
    $.ajax({
      type: 'DELETE',
      url: `/api/v4/upload_links/${uploadLinkKey}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      context: this,
      success: () => {
        this.setState((prevState) => (
          { visibleLinks: prevState.visibleLinks.filter((link) => link.key !== uploadLinkKey) }
        ));
      }
    });
  }

  formatDate = (railsDate) => {
    const jsDate = new Date(railsDate);
    return railsDate
      ? `${jsDate.getMonth() + 1}/${jsDate.getDate()}/${jsDate.getFullYear().toString().substr(-2)}`
      : null;
  }

  linksToShow() {
    const { visibleLinks, queryString } = this.state;
    return (queryString && queryString.length > 0) ? this.queriedLinks() : visibleLinks;
  }


  queriedLinks() {
    const { visibleLinks, queryString } = this.state;
    return visibleLinks.filter((link) => {
      const filterableString = `${link.key} ${link.created_by} ${link.description}
      ${this.formatDate(link.availability_end)} ${this.formatDate(link.created_at)}`.toLowerCase();
      return filterableString.includes(queryString.toLowerCase());
    });
  }

  renderSortingOptions() {
    return (
      <input
        id="upload-link-search"
        className="searchbar"
        type="text"
        placeholder={`Search ${this.props.uploadLinks.length} guest upload links`}
        onChange={this.updateSearch}
      />
    );
  }

  renderNoUploadLinks() {
    return (
      <div className="manage-upload-links">
        {`${BF.fx.brandfolder().name} does not have any guest upload links.`}
      </div>
    );
  }

  render() {
    if (this.props.uploadLinks && this.props.uploadLinks.length < 1) {
      return this.renderNoUploadLinks();
    }
    return (
      <div className="manage-upload-links">
        <h2>Manage Guest Upload Links for {BF.fx.brandfolder().name}</h2>
        <hr />
        {this.renderSortingOptions()}
        <div className="headers">
          <h3 className="ten">Link</h3>
          <h3 className="forty">Description</h3>
          <h3 className="fifteen">Created by</h3>
          <h3 className="ten">Upload Section</h3>
          <h3 className="ten center">Created</h3>
          <div className="five center" />
        </div>
        { this.linksToShow().map((link) => (
          <div className="guest-upload-row" key={link.key}>
            <GuestUploadsRow
              link={link}
              deleteGuestUploadLink={this.deleteGuestUploadLink}
              formatDate={this.formatDate}
            />
          </div>
        ))
        }
      </div>
    );
  }
}

GuestUploadsManagement.propTypes = {
  uploadLinks: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default GuestUploadsManagement;
